// Module
var code = "<div ng-if=\":: !message.arguments.length\"> <span>{{:: message.bundle | translate}}</span> </div> <div ng-repeat=\"innerArguments in ::message.arguments\"> <inner-arguments-message bundle=message.bundle arguments=innerArguments.arguments></inner-arguments-message> </div>";
// Exports
module.exports = code;